import dynamic from 'next/dynamic';

import { BackgroundColorDto } from '@/lib/marketing-page/dto/modules/shared';
import { WithDataTestId } from '@/types/with-data-testid';
import { getBackgroundSectionClassName } from '@/utils/marketing-landing-page';

import ImageLeftTextRight, {
  ImageLeftTextRightProps,
} from './ImageLeftTextRight';

import clsx from 'clsx';

const Carousel = dynamic(
  () =>
    import('@/components/Carousel/FullWidthItemCarousel').then(
      (mod) => mod.Carousel
    ),
  { ssr: false }
);
const CarouselItem = dynamic(
  () =>
    import('@/components/Carousel/FullWidthItemCarousel').then(
      (mod) => mod.CarouselItem
    ),
  { ssr: false }
);

type ImageLeftTextRightModuleProps = {
  items: ImageLeftTextRightProps[];
  containerClassName?: string;
  background?: BackgroundColorDto;
  valueToBeReplacedObj?: Record<string, string>;
} & WithDataTestId;

export default function ImageLeftTextRightModule({
  items,
  containerClassName,
  dataTestId,
  background,
  valueToBeReplacedObj,
}: ImageLeftTextRightModuleProps) {
  if (items.length === 1) {
    return (
      <section
        className={clsx(
          containerClassName,
          getBackgroundSectionClassName(background?.color)
        )}
        data-testid={dataTestId}
      >
        <ImageLeftTextRight
          {...items[0]}
          valueToBeReplacedObj={valueToBeReplacedObj}
          backgroundColor={background?.color}
          isImageRight={items[0]?.imagePosition === 'right'}
        />
      </section>
    );
  }

  return (
    <section
      className={clsx(
        'py-10 md:py-14',
        containerClassName ?? 'medium-container'
      )}
      data-testid={dataTestId}
    >
      <Carousel>
        {items.map((item) => (
          <CarouselItem key={item.title} width="100%">
            <ImageLeftTextRight
              {...item}
              isInCarousel={true}
              valueToBeReplacedObj={valueToBeReplacedObj}
              backgroundColor={background?.color}
            />
          </CarouselItem>
        ))}
      </Carousel>
    </section>
  );
}
